export const lifemeasureColors = {
    below: '#34D399',
    above: '#D1FAE5',
    active: '#059669'
};